import { render, staticRenderFns } from "./NewPaymentsEditAdmin.vue?vue&type=template&id=4f48f830&scoped=true"
import script from "./NewPaymentsEditAdmin.vue?vue&type=script&lang=js"
export * from "./NewPaymentsEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f48f830",
  null
  
)

export default component.exports